import React, { Component } from 'react';
import './admin.css';

export default class AdminCity extends Component {
  constructor(props) {
    super(props);
    var additionalStateValues = this.getAdditionalStateValues(
      this.props.settings
    );

    let coordinates = JSON.stringify(props.settings.markersCoordinates);
    this.state = {
      markersCoordinates: coordinates,
      isSubtitleRequiresChange: false,
      isMapDirty: false,
      isChangingLocationNotAllowed: false,
      ...additionalStateValues,
    };
  }

  getAdditionalStateValues(settings) {
    let styleSrcFolder = null;
    let initialMapWidth = null;
    let initialMapHeight = null;
    let initialPadding = null;
    if (settings && settings.urlQuery) {
      if (settings.urlQuery.styleSrc) {
        let lastIndex = settings.urlQuery.styleSrc.lastIndexOf('/');
        styleSrcFolder = settings.urlQuery.styleSrc.substring(0, lastIndex + 1);
      }
      initialMapWidth = settings.urlQuery.mapWidth;
      initialMapHeight = settings.urlQuery.mapHeight;
      initialPadding = settings.urlQuery.padding;
    }
    return {
      styleSrcFolder,
      initialMapWidth,
      initialMapHeight,
      initialPadding,
    };
  }

  getStyleSettingsByStyleId = (styleId) => {
    try {
      let styleSrc = this.state.styleSrcFolder;

      switch (styleId) {
        case 'modern':
          styleSrc += 'V3/oModernV3.json';
          break;
        case 'simple':
          styleSrc += 'V3/oSimpleV3.json';
          break;
        case 'blue':
          styleSrc += 'V3/oBlueV3.json';
          break;
        case 'tender':
          styleSrc += 'V3/oTenderV3.json';
          break;
        case 'black':
          styleSrc += 'V3/oBlackV3.json';
          break;
        case 'vintage':
          styleSrc += 'V3/oVintageV3.json';
          break;
        case 'red':
          styleSrc += 'V3/oRedV3.json';
          break;
        case 'paste':
          styleSrc += 'V3/oPasteV3.json';
          break;
        case 'harvest':
          styleSrc += 'V3/oHarvestV3.json';
          break;
        case 'bayside':
          styleSrc += 'V3/oBaysideV3.json';
          break;
        case 'plum':
          styleSrc += 'V3/oPlumV3.json';
          break;
        case 'leaf':
          styleSrc += 'V3/oLeafV3.json';
          break;
        case 'leaf2':
          styleSrc += 'V3/oLeafV3.json';
          break;
        default:
          throw 'Не могу найти стиль: ' + styleId;
      }
      return {
        styleSrc,
      };
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  };

  onStyleChange = (event) => {
    var value = event.target.value;
    var settings = { ...this.props.settings };
    var urlQuery = { ...this.props.settings.urlQuery };
    var styleSettings = this.getStyleSettingsByStyleId(value);

    this.props.onSettingsChanged({
      ...settings,
      styleId: value,
      urlQuery: {
        ...urlQuery,
        style: value,
        ...styleSettings,
      },
    });
  };

  getMapSettingsByMaterialAndLabeStyle = (material, labelStyle) => {
    try {
      let padding = '';
      let mapWidth = '';
      let mapHeight = '';

      if (
        labelStyle === 'center' ||
        labelStyle === 'none' ||
        material === 'Холст'
      ) {
        padding = 0;
        mapWidth = this.props.settings.urlQuery.containerWidth;
        mapHeight = this.props.settings.urlQuery.containerHeight;
      } else {
        var paddingInt = 24;
        if (this.state.initialPadding && this.state.initialPadding !== '0') {
          paddingInt = parseInt(this.state.initialPadding);
        }

        padding = paddingInt + '';
        mapWidth = (
          parseInt(this.state.initialMapWidth) -
          2 * paddingInt
        ).toString();
        mapHeight = (
          parseInt(this.state.initialMapHeight) -
          2 * paddingInt
        ).toString();
      }
      return {
        padding,
        mapWidth,
        mapHeight,
      };
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  };

  onMaterialChange = (event) => {
    var value = event.target.value;
    var settings = { ...this.props.settings };
    var urlQuery = { ...this.props.settings.urlQuery };

    this.setState({ isMapDirty: true });

    var mapSettings = this.getMapSettingsByMaterialAndLabeStyle(
      value,
      this.props.settings.labelStyle
    );

    this.props.onSettingsChanged({
      ...settings,
      material: value,
      urlQuery: {
        ...urlQuery,
        ...mapSettings,
      },
    });
  };

  onSizeChange = (event) => {
    var value = event.target.value;

    let split = value.split(/[\sxXхХ]+/);
    let width = parseInt(split[0], 10) * 10;
    let height = parseInt(split[1], 10) * 10;

    this.setState({ isMapDirty: true });

    var settings = { ...this.props.settings };
    var urlQuery = { ...this.props.settings.urlQuery };

    this.props.onSettingsChanged({
      ...settings,
      size: value,
      urlQuery: {
        ...urlQuery,
        printWidth: width,
        printHeight: height,
      },
    });
  };

  onLabelStyleChange = (event) => {
    var value = event.target.value;

    this.setState({ isMapDirty: true });

    var settings = { ...this.props.settings };
    var urlQuery = { ...this.props.settings.urlQuery };

    var mapSettings = this.getMapSettingsByMaterialAndLabeStyle(
      this.props.settings.material,
      value
    );

    this.props.onSettingsChanged({
      ...settings,
      labelStyle: value,
      urlQuery: {
        ...urlQuery,
        ...mapSettings,
      },
    });
  };

  onInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const type = target.type;
    let value = null;

    if (type == 'checkbox') {
      value = target.checked;
    } else {
      value = target.value;
    }

    var settings = { ...this.props.settings };
    this.props.onSettingsChanged({
      ...settings,
      [name]: value,
    });
  };

  onMarkersCoordinatesInputChange = (event) => {
    var value = event.target.value;

    this.setState({
      markersCoordinates: value,
    });
  };

  onUrlQueryInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const type = target.type;
    let value = null;

    if (type == 'checkbox') {
      value = target.checked;
    } else {
      value = target.value;
    }

    var settings = { ...this.props.settings };
    var urlQuery = { ...this.props.settings.urlQuery };

    var isSubtitleRequiresChange = false;
    var isMapDirty = false;
    if (name === 'centerLon' || name === 'centerLat') {
      isSubtitleRequiresChange = true;
      isMapDirty = true;
    } else if (name === 'zoom') {
      isMapDirty = true;
    }

    this.setState({
      isSubtitleRequiresChange,
      isMapDirty,
    });

    this.props.onSettingsChanged({
      ...settings,
      urlQuery: {
        ...urlQuery,
        [name]: value,
      },
    });
  };

  getUrlQuery = (obj) => {
    let query = '?';
    query += Object.keys(obj)
      .map(function (key) {
        return `${key}=${obj[key]}`;
      })
      .join('&');

    return query;
  };

  generateConfigFileFromState = () => {
    let query = this.getUrlQuery(this.props.settings.urlQuery);

    var result = {
      ...this.props.settings,
      urlQuery: query,
    };

    var stringResult = JSON.stringify(result, null, 2);

    console.log(stringResult);
    return stringResult;
  };

  handleSubmit = (event) => {
    event.preventDefault();
    let that = this;
    this.validateForm(() => {
      var content = that.generateConfigFileFromState();
      that.props.onSaveFile(content);
    });
  };

  sendToOrder = (event) => {
    event.preventDefault();
    this.validateForm(() => {
      var content = this.generateConfigFileFromState();
      this.props.onSendFileToOrder(content);
    });
  };

  validateMarkers = () => {
    //if (this.props.settings.)
  };

  validateForm(callback) {
    try {
      var obj = JSON.parse(this.state.markersCoordinates);
      var settings = { ...this.props.settings };
      this.props.onSettingsChanged(
        {
          ...settings,
          markersCoordinates: obj,
        },
        callback
      );
    } catch (e) {
      this.props.onShowError(
        `Неверный формат координат. Необходим [[lat,lng],[lat,lng]...]`
      );
    }
  }

  render() {
    let hangerOptions = [
      'Нет',
      'Рамка',
      'Лента',
      'Крючки',
      'Деревянный подрамник',
    ];
    let isHangerNotValid = false;
    let material = this.props?.settings?.material;
    let hanger = this.props?.settings?.hanger;
    if (material === 'Бумага') {
      if (hanger !== 'Нет' && hanger !== 'Рамка') {
        isHangerNotValid = true;
      }
    } else if (material === 'ПВХ') {
      if (hanger !== 'Нет' && hanger !== 'Рамка' && hanger !== 'Лента') {
        isHangerNotValid = true;
      }
    } else if (material === 'Холст') {
      if (hanger !== 'Крючки' && hanger !== 'Деревянный подрамник') {
        isHangerNotValid = true;
      }
    }
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="form-row">
          <div className="form-group col-md-3">
            <label for="orderIdInput">Номер заказа</label>
            <input
              type="text"
              className="form-control"
              id="orderIdInput"
              name="orderId"
              value={this.props.settings.orderId}
              onChange={this.onInputChange}
              required
            />
          </div>
          <div className="form-group col-md-3">
            <label for="materialInput">Материал</label>
            <select
              id="materialInput"
              className="form-control"
              name="material"
              value={this.props.settings.material}
              onChange={this.onMaterialChange}
            >
              <option disabled selected value>
                -- select an option --
              </option>
              <option value="Бумага">Бумага</option>
              <option value="ПВХ">ПВХ</option>
              <option value="Холст">Холст</option>
            </select>
          </div>
          <div className="form-group col-md-3">
            <label for="sizeImput">Размер</label>
            <select
              id="sizeImput"
              className="form-control"
              value={this.props.settings.size}
              onChange={this.onSizeChange}
            >
              <option disabled selected value>
                -- select an option --
              </option>
              <option value="30х40 см">30х40 см</option>
              <option value="50х70 см">50х70 см</option>
              <option value="70х100 см">70х100 см</option>
              <option value="100х140 см">100х140 см</option>
              {/*<option value="70х100 см">70х100 см</option>*/}
            </select>
          </div>
          <div className="form-group col-md-3">
            <label for="hangerInput">Держатель</label>
            <select
              id="hangerInput"
              className="form-control"
              name="hanger"
              value={this.props.settings.hanger}
              onChange={this.onInputChange}
            >
              <option disabled selected value>
                -- select an option --
              </option>
              {hangerOptions.map((s) => {
                return <option value={s}>{s}</option>;
              })}
            </select>
          </div>
        </div>

        <div className="form-row align-items-center">
          <div className="form-group col-md-3">
            <label for="styleInput">Стиль</label>
            <select
              id="styleInput"
              className="form-control"
              value={this.props.settings.styleId}
              onChange={this.onStyleChange}
            >
              <option disabled selected value>
                -- select an option --
              </option>
              <option value="modern">modern</option>
              <option value="simple">simple</option>
              <option value="blue">blue</option>
              <option value="tender">tender</option>
              <option value="black">black</option>
              <option value="vintage">vintage</option>
              <option value="red">red</option>
              <option value="paste">paste</option>
              <option value="harvest">harvest</option>
              <option value="bayside">bayside</option>
              <option value="plum">plum</option>
              <option value="leaf">leaf</option>
            </select>
          </div>
          <div className="form-group col-md-3">
            <label for="labelStyleInput">Надпись</label>
            <select
              id="labelStyleInput"
              className="form-control"
              value={this.props.settings.labelStyle}
              onChange={this.onLabelStyleChange}
            >
              <option disabled selected value>
                -- select an option --
              </option>
              <option value="gradient">gradient</option>
              <option value="center">center</option>
              <option value="bottom">bottom</option>
              <option value="circle">circle</option>
              <option value="none">none</option>
            </select>
          </div>
          <div className="form-group col-md-3">
            <label for="markersStyleInput">Метка</label>
            <select
              id="markersStyleInput"
              className="form-control"
              value={this.props.settings.markersStyle}
              name="markersStyle"
              onChange={this.onInputChange}
            >
              <option disabled selected value>
                -- select an option --
              </option>
              <option value="none">none</option>
              <option value="home">home</option>
              <option value="pin">pin</option>
              <option value="heart">heart</option>
            </select>
          </div>
          <div className="form-group col-md-3">
            <label for="markersCoordinatesInput">Координаты меток</label>
            <input
              type="text"
              className="form-control"
              id="markersCoordinatesInput"
              name="markersCoordinates"
              value={this.state.markersCoordinates}
              onChange={this.onMarkersCoordinatesInputChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-3">
            <label for="latitudeInput">Широта</label>
            <input
              type="text"
              className="form-control"
              id="latitudeInput"
              name="centerLat"
              value={this.props.settings.urlQuery.centerLat}
              onChange={this.onUrlQueryInputChange}
              required
            />
          </div>
          <div className="form-group col-md-3">
            <label for="longitudeInput">Долгота</label>
            <input
              type="text"
              className="form-control"
              id="longitudeInput"
              name="centerLon"
              value={this.props.settings.urlQuery.centerLon}
              onChange={this.onUrlQueryInputChange}
              required
            />
          </div>
          <div className="form-group col-md-3">
            <label for="zoomInput">Масштаб</label>
            <input
              type="text"
              className="form-control"
              id="zoomInput"
              name="zoom"
              value={this.props.settings.urlQuery.zoom}
              onChange={this.onUrlQueryInputChange}
              required
            />
          </div>
          <div className="form-group col-md-3">
            <label for="pitchInput">Поворот</label>
            <input
              type="text"
              className="form-control"
              id="pitchInput"
              name="pitch"
              value={this.props.settings.urlQuery.pitch}
              onChange={this.onUrlQueryInputChange}
              required
            />
          </div>
        </div>
        <div
          className={
            'alert alert-warning ' +
            (this.state.isSubtitleRequiresChange ? '' : 'd-none')
          }
          role="alert"
        >
          *При изменении координат необходимо вручную изменить текст
          Подзаголовка
        </div>
        <div
          className={
            'alert alert-danger ' +
            (this.state.isMapDirty &&
            this.props.settings.markersStyle !== 'none'
              ? ''
              : 'd-none')
          }
          role="alert"
        >
          *При наличии меток нельзя менять центр и масштаб карты, материал и
          размер.
        </div>
        <div
          className={'alert alert-warning ' + (isHangerNotValid ? '' : 'd-none')}
          role="alert"
        >
          *Некорректный держатель для выбранного материала.
        </div>
        <div className="form-row">
          <div className="form-group col-md-6">
            <label for="titleInput">Заголовок</label>
            <textarea
              className="form-control"
              id="titleInput"
              rows="5"
              name="title"
              value={this.props.settings.title}
              onChange={this.onInputChange}
            ></textarea>
          </div>
          <div className="form-group col-md-6">
            <label for="subtitleInput">Подзаголовок</label>
            <textarea
              className="form-control"
              id="subtitleInput"
              rows="5"
              name="subtitle"
              value={this.props.settings.subtitle}
              onChange={this.onInputChange}
            ></textarea>
          </div>
        </div>
        <button
          className="mt-1 mr-1 btn u-btn-primary g-font-size-13 g-py-10"
          onClick={this.sendToOrder}
        >
          Отправить на order
        </button>
        <button
          type="submit"
          className="mt-1 btn u-btn-primary g-font-size-13 g-py-10"
        >
          Скачать файл
        </button>
      </form>
    );
  }
}
